module.exports = new __parcel__URL__("branch-details-popup.tpl.90980aef.svg").toString();